/**
 * To save the original name of the image and to make it unique it saved with such a pattern
 * generatedRandomString + DIVIDE_SIGN + image.name
 * This function helps extract the image name from the link
 * */

export const DIVIDE_SIGN = '$'

export const getFileNameFromImagekitLink = (link: string) => {
  const endIndex = link.lastIndexOf('?')
  return link.substring(link.lastIndexOf(DIVIDE_SIGN) + 1, endIndex === -1 ? link.length : endIndex)
}
